<div class="flex flex-column p-1 m-1">
  <p-toast />
  <p-confirmdialog />
  <div>
    <h2>Caches Administration</h2>
    <p>Manage application caches here. Only populated / initialized caches will appear here.</p>
    <!-- Placeholder for future cache management UI -->
    <div>
      <div class="flex w-12 flex-align-content-end">
        <p-button-group>
          <button pButton type="button" label="Clear all caches" (click)="deleteAllCaches()" icon="pi pi-trash" iconPos="left"
              class="p-button-danger"></button>
          <button pButton type="button" label="Warmup all caches" (click)="warmupCaches()" icon="fa fas fa-fire" iconPos="left"
              class="p-button-success"></button>
          <button pButton type="button" label="Reload all caches" (click)="reload()" icon="pi pi-sync" iconPos="left"
          class="p-button-info"></button>
        </p-button-group>
      </div>
    </div>
    <p-table
      [value]="cacheNames"
      [paginator]="true"
      [rows]="10"
      responsiveLayout="stack"
      [loading]="loading"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-cache>
        <tr>
          <td><span class="p-column-title">Name</span>{{ cache }}</td>
          <td>
            <button
              pButton
              type="button"
              icon="pi pi-trash"
              iconPos="left"
              class="p-button-danger"
              (onClick)="deleteCache(cache)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
